import React, { useMemo } from 'react';
import { css, Global } from '@emotion/react';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import { globalCSS } from './globalCSS';
import { defaultTheme } from './default.theme';

// eslint-disable-next-line react/prop-types
export const GlobalStyles = ({ theme, isKiosk, isHighContrast }) => {
  const fontFamilies = get(theme, 'default.typography.fontFamilies');

  const bodyStyles = useMemo(
    () => css`
      body {
        color: ${get(theme, 'default.color.black')};
      }

      ${isHighContrast
        ? `
        img {
          filter: contrast(108%);
        }
          `
        : ''}
    `,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [theme, defaultTheme, isHighContrast]
  );
  const kioskStyles = useMemo(
    () => css`
      *,
      *::before,
      *::after {
        -webkit-touch-callout: none;
        user-select: none;
      }
      body {
        -webkit-touch-callout: none;
      }
    `,
    []
  );
  const appGlobalStyles = useMemo(
    () => [
      // array of mixed strings and objects with CSS styles that will be merged into a single stylesheet and applied to the global scope
      globalCSS,
      bodyStyles,
      get(theme, 'default.typography.fonts') || get(defaultTheme, 'default.typography.fonts'), // these are external font resources @font-face CSS types
      {
        'body, button': {
          fontFamily: uniq(fontFamilies.filter(item => item))
            .map(family => `"${family}"`)
            .join(','),
        },
      },
      isKiosk && kioskStyles,
    ],
    [bodyStyles, theme, isKiosk, kioskStyles, fontFamilies]
  );
  const composedAppStyles = useMemo(() => css(appGlobalStyles), [appGlobalStyles]);

  return <Global styles={composedAppStyles} />;
};
